/**
 * This file is generated by `pnpm codegen` from the OpenAPI spec, DO NOT EDIT.
 */

import makeMutationHook from 'core/types/makeMutationHook'
import makeQueryHook from 'core/types/makeQueryHook'
import * as operations from 'core/types/operations'

export const useLoanTransactionsGetAll = makeQueryHook(
  operations.loanTransactionsGetAll,
)

export const useTransactionsCreate = makeMutationHook(
  operations.transactionsCreate,
)

export const useTransactionsGetById = makeQueryHook(
  operations.transactionsGetById,
)

export const useTransactionsUpdate = makeMutationHook(
  operations.transactionsUpdate,
)

export const useTransactionCancel = makeMutationHook(
  operations.transactionCancel,
)

export const useTransactionsFailMultiple = makeMutationHook(
  operations.transactionsFailMultiple,
)

export const useTransactionReverse = makeMutationHook(
  operations.transactionReverse,
)

export const useGetChargebacks = makeQueryHook(operations.getChargebacks)

export const useTransactionChargeback = makeMutationHook(
  operations.transactionChargeback,
)

export const useGetChargebackById = makeQueryHook(operations.getChargebackById)

export const useUpdateChargeback = makeMutationHook(operations.updateChargeback)

export const useTransactionBackdate = makeMutationHook(
  operations.transactionBackdate,
)

export const useAliasLoanTransactionsGetAll = makeQueryHook(
  operations.aliasLoanTransactionsGetAll,
)

export const useInternalTransactionsCreate = makeMutationHook(
  operations.internalTransactionsCreate,
)

export const useAliasTransactionsGetById = makeQueryHook(
  operations.aliasTransactionsGetById,
)

export const useAliasTransactionsUpdate = makeMutationHook(
  operations.aliasTransactionsUpdate,
)

export const useAliasTransactionCancel = makeMutationHook(
  operations.aliasTransactionCancel,
)

export const useAliasTransactionsFailMultiple = makeMutationHook(
  operations.aliasTransactionsFailMultiple,
)

export const useAliasTransactionReverse = makeMutationHook(
  operations.aliasTransactionReverse,
)

export const useAliasGetChargebacks = makeQueryHook(
  operations.aliasGetChargebacks,
)

export const useAliasTransactionChargeback = makeMutationHook(
  operations.aliasTransactionChargeback,
)

export const useAliasGetChargebackById = makeQueryHook(
  operations.aliasGetChargebackById,
)

export const useAliasUpdateChargeback = makeMutationHook(
  operations.aliasUpdateChargeback,
)
